<template>
    <div class="flex justify-between flex-1 space-x-3 sm:justify-end">
        <a
            v-if="hasPreviousPage"
            class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            @click.prevent="prevPage"
        >{{ 'Previous' }}</a>

        <!-- <template v-for="(page, index) in pages">
            <span
                v-if="page === null"
                :key="`separator-${index}`"
                class="DatatablePagination--separator"
            >…</span>
            <a
                v-else
                :key="page"
                :class="{'DatatablePagination--button': true, 'current': currentPage === page}"
                @click.prevent="selectPage(page)"
                v-text="page"
            ></a>
        </template> -->

        <a
            v-if="hasNextPage"
            class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            @click.prevent="nextPage"
        >{{ 'Next' }}</a>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: null,
        },
        total: {
            type: Number,
            default: null,
        },
        pageLength: {
            type: Number,
            default: null,
        },
    },

    data () {
        return {
            start: this.value,
        };
    },

    computed: {

        /**
     * If has a valid next page
     * @return {Boolean}
     */
        hasNextPage () {
            return this.currentPage < this.totalPages;
        },

        /**
     * If has a valid previous page
     * @return {Boolean}
     */
        hasPreviousPage () {
            return this.start > 0;
        },

        /**
     * Calculate the current page number
     * @return {Number}
     */
        currentPage () {
            return (this.start / this.pageLength) + 1;
        },

        /**
     * Calculate the total number of pages
     * @return {Number}
     */
        totalPages () {
            return Math.ceil(this.total / this.pageLength);
        },

        /**
     * Returns an array with the pages that will appear in the pagination
     *
     * @return {Array}
     */
        pages () {
            if (this.totalPages < 1) {
                return [];
            }

            const pages = [1];

            if (this.totalPages === 1) {
                return pages;
            }

            if (this.currentPage < 5) {
                for (let i = 2; i < this.totalPages && i <= 5; i += 1) {
                    pages.push(i);
                }
            } else if (this.currentPage > this.totalPages - 4) {
                if (pages[pages.length - 1] < this.currentPage - 2) {
                    // Separator
                    pages.push(null);
                }
                for (let i = this.totalPages - 4; i < this.totalPages; i += 1) {
                    pages.push(i);
                }
            } else {
                if (pages[pages.length - 1] < this.currentPage - 2) {
                    // Separator
                    pages.push(null);
                }
                pages.push(this.currentPage - 1);
                pages.push(this.currentPage);
                pages.push(this.currentPage + 1);
            }

            if (! pages.includes(this.totalPages)) {
                if (pages[pages.length - 1] < this.totalPages - 1) {
                    // Separator
                    pages.push(null);
                }

                pages.push(this.totalPages);
            }

            return pages;
        },
    },

    watch: {

        /**
     * If the value of the v-model change set the new value to the current start
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
        value (value) {
            this.start = value;
        },
    },

    methods: {

        /**
     * Select the page used a parameter
     * @param  {Number} page
     */
        selectPage (page) {
            if (this.currentPage === this.page) {
                return;
            }

            const start = this.pageLength * (page - 1);
            this.$emit('input', start);
            this.$emit('change');
        },

        /**
     * Set prev page
     */
        prevPage () {
            if (! this.hasPreviousPage) {
                return;
            }
            this.selectPage(this.currentPage - 1);
        },

        /**
     * Set next page
     */
        nextPage () {
            if (! this.hasNextPage) {
                return;
            }
            this.selectPage(this.currentPage + 1);
        },
    },
};
</script>

<style>
.DatatablePagination--button  {
  border: 1px solid #d2d8e2;
  color: #0959ae !important;
  background: #f1f3f6 !important;
  padding: 0.2em 0.4em !important;
  font-weight: 600 !important;
  font-size: 1rem !important;
  border-radius: 3px !important;
  box-sizing: border-box;
  display: inline-block;
  min-width: 1.5rem;
  margin-left: 3px;
  text-align: center;
  text-decoration: none !important;
  text-transform: none !important;
  cursor: pointer;
  *cursor: hand;
}
.DatatablePagination--button.current {
  border-color: #0959ae !important;
  color: #fafcfc !important;
  background: #0959ae !important;
}
.DatatablePagination--button.disabled {
  cursor: default;
  color: #8ba1b1 !important;
  border: 1px solid #c6d0d9;
  background: transparent;
  box-shadow: none;
}
.DatatablePagination--separator {
  padding: 0 1em;
}
</style>
